import { ReactNode } from 'react';

export const OrderDetailsFieldAnchor = ({
  fieldName,
  children,
}: {
  fieldName: string;
  children: ReactNode;
}) => <div data-order-details-field={fieldName}>{children}</div>;
